module.exports = __webpack_public_path__ + "static/media/nk_logo_nk_nyukom_alt.0d0f3cdf.png";